import { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import "../App.css";

import Services from './Services'
import 'react-confirm-alert/src/react-confirm-alert.css';
import Popup from 'reactjs-popup';

import 'reactjs-popup/dist/index.css';
import { RotatingLines } from "react-loader-spinner";
import * as AiIcons from 'react-icons/ai';
import { MDBCardText, MDBTypography } from 'mdb-react-ui-kit';
import { Card } from "reactstrap";
import Pagination from "rc-pagination";
import "./pagination.css";

const moment = require("moment");

const EmployeeDayAttendance = () => {

    var today = moment(new Date(), "DD/MM/YYYY").toDate();

    const [masterdata, setmasterdata] = useState({
        f_date: today.toISOString().slice(0, 10)
    });

    const [loading, setLoading] = useState(false);
    const [staffdata, setStaffdata] = useState([]);
    const [staffTotaldata, setStaffTotaldata] = useState([]);

    function handleChangeHospitaltypes(event, frm) {
        setStaffTotaldata([]);
        closeleadsfromdata();

        const { name, value } = event.target;
        setmasterdata({ ...masterdata, [name]: value });
    }

    useEffect(() => {
        const fetchStaffData = async () => {
            try {
                setStaffdata([]);
                const res = await Services.getStafflistdata({});
                if (res.status === 200) {
                    const activeStaff = res.data.staffdata.filter(
                        staff => staff.staff_status === "Active"
                    );
                    setStaffdata(activeStaff);
                }
            } catch (error) {
                console.error("Failed to fetch staff data", error);
                setStaffdata([]);
            }
        };

        fetchStaffData();
    }, []);


    const getData = async () => {

        if (!validateForm()) return;

        setLoading(true);
        setStaffTotaldata([]);

        const toDate = moment(masterdata.f_date).format("DD-MM-YYYY");

        if (staffdata.length === 0) {
            setLoading(false);
            return;
        }

        const finalData = [];

        for (let staff of staffdata) {
            try {
                // 1. Get Unique Number
                const uniqueRes = await Services.empGetuniquenumber(staff.staff_mobile_nu, staff.staff_aadharno);
                if (uniqueRes.status !== 200 || !uniqueRes.data.data.length) {
                    console.log("Employee not found");
                    continue;
                }

                const uniqueList = uniqueRes.data.data;
                const lastAttendance = uniqueList[uniqueList.length - 1];
                const empUniqueNu = lastAttendance.emp_unique_nu?.trim();
                if (!empUniqueNu) {
                    console.log("Invalid Unique Number");
                    continue;
                }

                // 2. Get Patient Data (Delivery + Discharge)
                const patientRes = await Services.getEmpEntryPatientsdata(staff.hospital_type, staff.hospital_code, staff.login_user_nm, toDate, toDate);
                console.log(patientRes.data)

                console.log(staff.hospital_type + "-" + staff.hospital_code + "-" + empUniqueNu + "-" + toDate);
                const delivarys = patientRes.status === 200 ? patientRes.data.createdpatients : [];
                const discharges = patientRes.status === 200 ? patientRes.data.dischargedpatients : [];


                // 3. Get Attendance + Workupdate
                const attendanceFilter = { from_dt: toDate, to_dt: toDate, emp_unique_nu: empUniqueNu };
                const workRes = await Services.empGetAttendanceWorkupdate(attendanceFilter);
                const attendancedata = workRes.status === 200 ? workRes.data.data.attendance : {};
                const workupdatedata = workRes.status === 200 ? workRes.data.data.workStatus : {};

                // 4. Combine into final entry
                finalData.push({
                    staff_display_nm: staff.staff_display_nm,
                    workdate: toDate,
                    hospital: `${staff.hospital_type}-${staff.hospital_code}`,
                    attendancedata,
                    workupdatedata,
                    delivarys,
                    discharges
                });

            } catch (error) {
                console.error("Error processing staff:", staff.staff_display_nm, error);
                alert(`Error processing ${staff.staff_display_nm}`);
            }
        }

        setStaffTotaldata(finalData);   
        setLoading(false);

        if (finalData.length === 0) {
            alert("No data found for the given date");
        }
    };

    const validateForm = (e) => {
        let formIsValid = true;
        if (!masterdata.f_date?.trim()) {
            alert("Please select date.");
            formIsValid = false;
        }
        return formIsValid;
    }

    const JoiningPatients = ({ patientsdata, report_dateval, report_type }) => {
        if (report_type === "deliveries") {
            return renderReportCount(patientsdata, report_dateval, report_type, "patient_created_by_date");
        } else if (report_type === "discharges") {
            return renderReportCount(patientsdata, report_dateval, report_type, "patient_discharged_by_date");
        }
    };


    const renderReportCount = (patientsdata, report_dateval, report_type, filterKey) => {
        const datesval = patientsdata.filter(current =>
            current[filterKey] === report_dateval
        ).map(current => current[filterKey]);

        const count = datesval.length;
        const color = count === 0 ? "black" : "#007bff";
        const content = (
            <b style={{ color, marginRight: "5px", marginLeft: "5px", cursor: count > 0 ? "pointer" : "default" }}
                onClick={count > 0 ? (e) => openleadsfromdata(patientsdata, report_dateval, report_type) : undefined}>
                {count > 0 ? <u>{count}</u> : count}
            </b>
        );
        return (
            <MDBCardText className="d-flex fw-normal mt-1 mb-0" style={{ width: "100%" }}>
                {content}
            </MDBCardText>
        );
    };

    const [patientsdataView, setPatientsdataView] = useState("NO");
    const [patientsdataViewloading, setPatientsdataViewloading] = useState(false);
    const [patientsdata, setPatientsdata] = useState([]);

    const openleadsfromdata = (patientsdata, report_dateval, report_type) => {
        setPatientsdataView("YES");
        getDashboardLeadsfromdata(patientsdata, report_dateval, report_type);
    }

    const closeleadsfromdata = () => {
        setPatientsdataView("NO");
        setPatientsdataViewloading(false);
        setPatientsdata([]);

    }

    const getDashboardLeadsfromdata = async (LeadFromwisedayitem, report_dateval, report_type) => {
        setPatientsdataViewloading(true);
        setPatientsdata([]);

        var leadfromwisedatewisedata = [];
        for (let j = 0; j < LeadFromwisedayitem.length; j++) {
            if (report_type === "deliveries") {
                if (LeadFromwisedayitem[j].patient_created_by_date === report_dateval) {
                    leadfromwisedatewisedata.push(LeadFromwisedayitem[j]);
                }
            } else if (report_type === "discharges") {
                if (LeadFromwisedayitem[j].patient_discharged_by_date === report_dateval) {
                    leadfromwisedatewisedata.push(LeadFromwisedayitem[j]);
                }
            }
            if (LeadFromwisedayitem.length === j + 1) {
                setPatientsdata(leadfromwisedatewisedata);
                setPatientsdataViewloading(false);
            }
        }
    }

    const DashboardBranchwiseLeadsfromData = () => {
        return (
            <div className="start_center" style={{ width: "100%", marginTop: "5px", flexDirection: "column" }}>
                {/* Close Button */}
                <div className="end_center" style={{ width: "100%", padding: "10px", fontWeight: "bold" }}>
                    <AiIcons.AiFillCloseSquare
                        onClick={closeleadsfromdata}
                        style={{ color: "red", height: "25px", width: "25px", cursor: "pointer" }}
                    />
                </div>

                {/* Loading Spinner */}
                {patientsdataViewloading ? (
                    <div className="center_center" style={{ width: "100%", display: "flex" }}>
                        <RotatingLines
                            width="50px"
                            height="50px"
                            strokeColor="red"
                            strokeWidth="5"
                            animationDuration="0.75"
                            visible={true}
                        />
                    </div>
                ) : (
                    <Card style={{ background: "#b3e5fc", borderRadius: "10px", width: "100%" }}>
                        <div className="start_start" style={{ padding: "10px", flexDirection: "column", width: "100%" }}>
                            <h1 style={{ marginLeft: "10px", fontSize: "14px", fontWeight: "bold", color: "red" }}>
                                Patient Full Details: {patientsdata.length}
                            </h1>

                            {/* Data Table */}
                            <Table striped bordered hover style={{ fontSize: "12px" }}>
                                <thead style={{ background: "lightsteelblue", color: "black" }}>
                                    <tr>
                                        <th>SNo</th>
                                        <th>Id</th>
                                        <th>Patient Name</th>
                                        <th>RCH ID</th>
                                        <th>Delivery Date</th>
                                        <th>Delivery Entry Date</th>
                                        <th>Discharged</th>
                                        <th>Discharge Entry Date</th>
                                        <th>Status</th>
                                        <th>View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData(current, size).map((patient, index) => (
                                        <tr key={index}>
                                            <td>{(current - 1) * perPage + index + 1}</td>
                                            <td>{patient.patient_id}</td>
                                            <td>{patient.patient_name}</td>
                                            <td>{patient.patient_rchid} {patient.patient_ipnumber}</td>
                                            <td>{patient.record_created_date}</td>
                                            <td>{patient.patient_created_by_date} {patient.patient_created_by_time}</td>
                                            <td>{patient.patient_discharged_date}</td>
                                            <td>{patient.patient_discharged_by_date} {patient.patient_discharged_by_time}</td>
                                            <td>
                                                <b style={{ color: patient.patient_status === "IN HOSPITAL" ? "green" : "red" }}>
                                                    {patient.patient_status}
                                                </b>
                                            </td>
                                            <td style={{ color: "blue", width: "1%" }}>
                                                <Popup
                                                    trigger={<u style={{ cursor: 'pointer' }}>View</u>}
                                                    position="top center"
                                                >
                                                    <div style={{ font: 'small-caption' }}>
                                                        <p><b>Mobile No:</b> {patient.patient_mobileno}</p>
                                                        <p><b>Alt Ph.No:</b> {patient.patient_alternative_mobileno}</p>
                                                        <p><b>Address:</b> {patient.patient_address}</p>
                                                        <p><b>Blood Group:</b> {patient.patient_blood_group}</p>
                                                    </div>
                                                </Popup>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>

                            {/* Pagination */}
                            <Pagination
                                className="pagination-data"
                                showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total}`}
                                onChange={paginationChange}
                                total={patientsdata.length}
                                current={current}
                                pageSize={size}
                                showSizeChanger={false}
                                showTitle={false}
                                itemRender={prevNextArrow}
                                onShowSizeChange={perPageChange}
                            />
                        </div>
                    </Card>
                )}
            </div>
        );
    };

    const [perPage] = useState(30);
    const [size, setSize] = useState(perPage);
    const [current, setCurrent] = useState(1);

    const perPageChange = (newSize) => {
        setSize(newSize);
        const maxPage = Math.ceil(patientsdata.length / newSize);
        if (current > maxPage) setCurrent(maxPage);
    };

    const currentData = (page, pageSize) =>
        patientsdata.slice((page - 1) * pageSize, page * pageSize);

    const paginationChange = (page, pageSize) => {
        setCurrent(page);
        setSize(pageSize);
    };

    const prevNextArrow = (current, type, originalElement) => {
        const icon = type === 'prev' ? "fa-angle-double-left" : "fa-angle-double-right";
        return type === 'page' ? originalElement : <button><i className={`fa ${icon}`}></i></button>;
    };

    const tableCellStyle = {
        border: "1px solid #d9e3f0",
        padding: "8px",
        verticalAlign: "top"
    };

    return (
        <div className="full_frame_center">
            <div style={{ background: "gainsboro", padding: 5, margin: 5 }}>
                <div className="start_center" style={{ width: "100%" }}>
                    <Card style={{ background: "#f7f7f7", margin: 5, borderRadius: 10, width: "100%" }}>

                        <Card className="rounded-top text-white d-flex flex-row" style={{ backgroundColor: "#fff" }}>
                            <div style={{ width: "100%", color: "#04043c", padding: 15 }}>
                                <MDBTypography tag="h5" className="fw-normal mb-0">
                                    <u>INFANT Employee Day Work</u>
                                </MDBTypography>

                                <div className="end_end" style={{ width: "100%", flexDirection: "row" }}>
                                    <div className="end_end" style={{ width: "10%", flexDirection: "column" }}>
                                        <input type="date" name="f_date" value={masterdata.f_date}
                                            style={{ fontSize: 12, width: "100%", padding: 6 , marginRight: 20 }}
                                            onChange={(e) => handleChangeHospitaltypes(e, "todate")} />
                                    </div>
                                    <div className="end_end" style={{flexDirection: "column" }}>
                                        <button className="btn btn-primary" style={{ background: "#191970",
                                         borderColor: "#191970", fontSize: 14, width: 100, marginRight: 20 }}
                                            onClick={getData} >
                                            GET DATA
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Card>
                        
                        {/* Loading or Data Table */}
                        <MDBCardText>
                            {loading ? (
                                <div className="center_center" style={{ width: "100%", display: "flex" }}>
                                    <RotatingLines width="50px" height="50px" strokeColor="red" strokeWidth="8" animationDuration="0.75" visible />
                                </div>
                            ) : (


                                <Card className="start_start" style={{
                                    width: "100%", flexDirection: "column",
                                    background: "white"
                                }}>

                                    <table style={{ width: "100%", fontSize: 12, textAlign: "start" }}>
                                        <thead style={{ background: "#0091ea", color: "white" }}>
                                            <tr style={{ height: 40 }}>
                                                <th style={tableCellStyle}>SNO</th>
                                                <th style={tableCellStyle}>EMP NAME</th>
                                                <th style={tableCellStyle}>HOSPITAL</th>
                                                <th style={tableCellStyle}>ATTENDANCE</th>
                                                <th style={tableCellStyle}>DELIVARY ENTRIES</th>
                                                <th style={tableCellStyle}>DISCHARGED ENTRIES</th>
                                                <th style={tableCellStyle}>WORK UPDATES</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {staffTotaldata.map((staff, index) => (
                                                <tr key={index} style={{ height: 40 }}>
                                                    <td style={tableCellStyle}>{index + 1}</td>
                                                    <td style={tableCellStyle}>
                                                        <b style={{ marginRight: 5, color: "#007bff" }}>{staff.staff_display_nm}</b>
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        <b style={{ marginRight: 5, color: "#007bff" }}>{staff.hospital}</b>
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {staff.attendancedata
                                                            .filter(att => att.wrk_dt === moment(masterdata.f_date).format("DD-MM-YYYY"))
                                                            .map((att, i) => (
                                                                <div key={i}>
                                                                    <MDBTypography className="fw-normal mb-0">
                                                                        <b style={{ marginRight: 5, color: "#007bff" }}>In time:</b>
                                                                        <b style={{ color: "red", marginLeft: 5 }}>{att.in_time}</b>
                                                                    </MDBTypography>
                                                                    <MDBCardText className="fw-normal" style={{ color: "#007bff" }}>
                                                                        <b>Out time:</b>
                                                                        <b style={{ color: "red", marginLeft: 5 }}>{att.out_time}</b>
                                                                    </MDBCardText>
                                                                </div>
                                                            ))}
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        <JoiningPatients patientsdata={staff.delivarys} report_dateval={staff.workdate} report_type="deliveries" />
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        <JoiningPatients patientsdata={staff.discharges} report_dateval={staff.workdate} report_type="discharges" />
                                                    </td>
                                                    <td style={tableCellStyle}>
                                                        {staff.workupdatedata
                                                            .filter(work => work.report_date === moment(masterdata.f_date).format("DD-MM-YYYY"))
                                                            .map((work, i) => (
                                                                <div key={i}>
                                                                    <MDBCardText className="fw-normal mb-0"><b>{work.sts_tm}</b></MDBCardText>
                                                                    <MDBCardText className="fw-normal mb-1" style={{ color: "#007bff" }}><b>{work.sts_desc_tx}</b></MDBCardText>
                                                                </div>
                                                            ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </Card>
                            )}
                        </MDBCardText>

                        <div style={{ borderTop: "2px solid #dfe3e7", marginBottom: 10 }} />

                        {patientsdataView === "YES" && <DashboardBranchwiseLeadsfromData />}
                    </Card>
                </div>
            </div>
        </div>
    );


};

export default EmployeeDayAttendance;
